export const EMAIL_PROVIDER = {
  SENDGRID: 0,
  MAILCHIMP: 1,
  MAILERSEND: 2,
  SMTP: 3,
}

export const PROVIDER_LABELS = {
  [EMAIL_PROVIDER.SENDGRID]: 'SendGrid',
  [EMAIL_PROVIDER.MAILCHIMP]: 'MailChimp',
  [EMAIL_PROVIDER.MAILERSEND]: 'MailerSend',
  [EMAIL_PROVIDER.SMTP]: 'SMTP',
}

export const SMTP_SECURITY = {
  NONE: 0,
  START_TLS: 1,
  SSL_ON_CONNECT: 2,
}

// Ports mirror the allow-list enforced by the backend; the default port follows
// the selected transport security.
export const SMTP_SECURITY_OPTIONS = [
  {
    value: SMTP_SECURITY.START_TLS,
    label: 'STARTTLS (recommended)',
    defaultPort: 587,
  },
  { value: SMTP_SECURITY.SSL_ON_CONNECT, label: 'SSL/TLS', defaultPort: 465 },
  { value: SMTP_SECURITY.NONE, label: 'None (unencrypted)', defaultPort: 25 },
]

// Analytics reads better with a name than with the wire value, and the numbers
// are free to change without rewriting saved charts.
export const SMTP_SECURITY_LABELS = {
  [SMTP_SECURITY.NONE]: 'none',
  [SMTP_SECURITY.START_TLS]: 'starttls',
  [SMTP_SECURITY.SSL_ON_CONNECT]: 'ssl',
}

export const SMTP_PORTS = [25, 465, 587, 2525]

export const SMTP_PRESET_CUSTOM = 'custom'

// Most collections do not run their own relay, so offering the two providers we
// see most often removes the need to know a hostname at all. Both reject the
// account password, which reads as a broken feature unless we say so up front.
//
// The labels name the mail host rather than the address, because a custom domain
// on Google Workspace still relays through Gmail. mailboxDomains only lists the
// free consumer domains: those are the ones an address can prove on its own.
export const SMTP_PRESETS = [
  {
    id: 'google',
    label: 'Google',
    host: 'smtp.gmail.com',
    port: 587,
    security: SMTP_SECURITY.START_TLS,
    mailboxDomains: ['gmail.com', 'googlemail.com'],
    passwordHint:
      'Google needs a 16-character App Password, not your account password. Create one at myaccount.google.com/apppasswords with 2-Step Verification turned on.',
  },
  {
    id: 'microsoft',
    label: 'Microsoft',
    host: 'smtp.office365.com',
    port: 587,
    security: SMTP_SECURITY.START_TLS,
    mailboxDomains: ['outlook.com', 'hotmail.com', 'live.com', 'msn.com'],
    passwordHint:
      'Most Microsoft accounts need an app password rather than the account password. Create one in your Microsoft account security settings.',
  },
]

export const SMTP_PRESET_HINT =
  'Pick the service that runs your mailbox, not your domain. A custom domain on Google Workspace is still Google.'

// The dead end this panel used to leave unsigned: a freshly bought domain has no
// mailbox to sign in to, and no amount of choosing between hosts will fix that.
export const SMTP_MAILBOX_NOTE =
  'SMTP signs in to a mailbox that already exists. If you own a domain but have no mailbox yet, use MailerSend instead: it sends from your domain with DNS records only.'

export const DEFAULT_SMTP_PORT = 587
